import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Btn, Card } from "../dash/Shell";

export default function AdminAI() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/ai/summary"); setText(data.summary); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Card title="AI operations summary" sub="GPT-5.2 reads recent bookings and subscription requests and gives you today's priorities in Telugu." testid="admin-ai">
      <Btn data-testid="ai-summary-button" onClick={run} disabled={busy}><Sparkles size={15} /> {busy ? "Thinking…" : "Generate summary"}</Btn>
      {text && (
        <pre data-testid="ai-summary-output" className="mt-6 whitespace-pre-wrap font-sans text-sm leading-relaxed text-slate-200 rounded-2xl border border-gold/20 bg-ink/60 p-5">{text}</pre>
      )}
    </Card>
  );
}
